import React from 'react'
import { Flex } from '@chakra-ui/react'
import Image from 'next/image'

import { Category } from 'appTypes/shop'

import { StyledCategoryCard, StyledName } from './styles'

type Props = {
  category: Category
  isCategorySelected?: boolean
}

export const CategoryCard: React.FC<Props> = ({ category, isCategorySelected = false }) => {
  return (
    <StyledCategoryCard isCategorySelected={isCategorySelected} className="gtm-category-block">
      {category.url && (
        <Flex width="100%" height="100%" alignItems="center" justifyContent="center" marginBottom="17px">
          <Image loading="eager" src={category.url} alt="Category image" width={120} height={120} />
        </Flex>
      )}

      <StyledName className="gtm-category-name" isCategorySelected={isCategorySelected}>
        {category.name}
      </StyledName>
    </StyledCategoryCard>
  )
}
